"use client"
import {
  cn
} from "./chunk-Q2O3JHTB.js";

// src/select/select.tsx
import Divider from "@a24/ui/Divider";
import Icon from "@a24/ui/Icon";
import * as RadixSelect from "@radix-ui/react-select";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var SelectItem = ({
  children,
  className,
  ref,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(RadixSelect.Item, { className: cn(className), ...props, ref, children: [
      /* @__PURE__ */ jsx(RadixSelect.ItemText, { className: "", children }),
      /* @__PURE__ */ jsx(RadixSelect.ItemIndicator, { className: "" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { className: "divider-faded" })
  ] });
};
var findSelectedOption = ({
  optionMatcher,
  options,
  selectedOption
}) => {
  if (!selectedOption && selectedOption !== 0) return void 0;
  if (!optionMatcher)
    return options.find(
      (o) => JSON.stringify(o.value) === JSON.stringify(selectedOption)
    );
  if (typeof options[0]?.value === "string")
    return options.find((o) => o.value === selectedOption);
  return options.find((o) => optionMatcher?.(o.value, selectedOption));
};
var Select = ({
  className,
  id,
  placeholder,
  options,
  optionMatcher,
  selectedOption,
  required,
  label,
  error,
  name,
  outerWrapperClassName,
  disabled,
  includeAllOption,
  initialValue,
  ref,
  onChange
}) => {
  if (!options || options.length === 0) return null;
  const _selectedOption = findSelectedOption({
    options,
    selectedOption,
    optionMatcher
  });
  const handleChange = (value) => {
    if (typeof options[0]?.value === "string") {
      onChange?.(value);
    } else {
      onChange?.(JSON.parse(value));
    }
  };
  return /* @__PURE__ */ jsx("div", { className: cn(outerWrapperClassName), children: /* @__PURE__ */ jsxs(
    RadixSelect.Root,
    {
      defaultValue: typeof initialValue === "string" ? initialValue : JSON.stringify(initialValue),
      required,
      name,
      disabled,
      onValueChange: handleChange,
      value: typeof _selectedOption?.value === "string" ? _selectedOption.value : JSON.stringify(_selectedOption?.value),
      children: [
        label && /* @__PURE__ */ jsx("label", { className: cn("select-label"), htmlFor: id, children: label }),
        /* @__PURE__ */ jsxs(
          RadixSelect.Trigger,
          {
            id,
            ref,
            "aria-invalid": !!error,
            className: cn(
              "select-trigger hover:cursor-pointer",
              error && "!border-heritage-red-full",
              error && "!text-heritage-red-full",
              className
            ),
            "aria-label": placeholder,
            children: [
              /* @__PURE__ */ jsx(
                RadixSelect.Value,
                {
                  placeholder,
                  className: cn("pl-2", error && "!text-heritage-red-full"),
                  children: /* @__PURE__ */ jsx("span", { children: _selectedOption?.label || placeholder })
                }
              ),
              /* @__PURE__ */ jsx(RadixSelect.Icon, { children: /* @__PURE__ */ jsx(
                Icon,
                {
                  height: 8,
                  width: 8,
                  className: cn(
                    "data-state-open-rotate-180 h-[0.7em]",
                    error && "!text-heritage-red-full"
                  ),
                  SVGClassName: "w-auto h-full",
                  name: "arrow-short-down"
                }
              ) })
            ]
          }
        ),
        error && /* @__PURE__ */ jsx("p", { className: "error-message", role: "alert", children: error }),
        /* @__PURE__ */ jsx(RadixSelect.Content, { position: "popper", className: "select-content", children: /* @__PURE__ */ jsx(RadixSelect.Viewport, { className: "select-content-viewport", children: /* @__PURE__ */ jsxs(RadixSelect.Group, { children: [
          includeAllOption && /* @__PURE__ */ jsx(
            SelectItem,
            {
              className: "select-item hover:cursor-pointer",
              value: "all",
              children: "All"
            },
            "AllListItem"
          ),
          options.map((option) => /* @__PURE__ */ jsx(
            SelectItem,
            {
              className: "select-item hover:cursor-pointer",
              value: typeof option.value === "string" ? option.value : JSON.stringify(option.value),
              children: option.label
            },
            typeof option.value === "string" ? option.value : JSON.stringify(option.value)
          ))
        ] }) }) })
      ]
    }
  ) });
};
var select_default = Select;

export {
  select_default
};
